import { useState, useRef } from 'react';
import socialmedia from '../../images/fb.png';
import Map from '../../images/map.png';
import { useTranslation } from "react-i18next";
import emailjs from '@emailjs/browser';

const Contact = () => {
    const { t, i18n } = useTranslation();
    const [inputValue, setInputValue] = useState({
        name: "",
        email: "",
        phone: "",
        msg: "",
    });
    const { name, email, phone, msg } = inputValue;
    const [captchaWord, setCaptchaWord] = useState('');
    const [status, setStatus] = useState('');
    const [errors, setErrors] = useState({
        name: false,
        email: false,
        phone: false,
        msg: false,
        captcha: false
    });

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value,
        });
    };

    const handleCaptchaChange = (e) => {
        setCaptchaWord(e.target.value);
    };

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        const newErrors = {
            name: !name.trim(),
            email: !email.trim(),
            phone: !phone.trim(),
            msg: !msg.trim(),
            captcha: captchaWord !== "Summit Partners Contracting"
        };

        setErrors(newErrors);

        if (Object.values(newErrors).some(err => err)) return;

        setStatus("sending");

        emailjs.sendForm('service_q5sad3i', 'template_kuds49v', form.current, 'e97JWS3qzdusKOx2F')
            .then(() => {
                setStatus("sent");
                setTimeout(() => {
                    setStatus("");
                    setInputValue({ name: "", email: "", phone: "", msg: "" });
                    setCaptchaWord('');
                    setErrors({ name: false, email: false, phone: false, msg: false, captcha: false });
                }, 2000);
            })
            .catch(error => {
                console.error(error.text);
            });
    };

    return (
        <div className="container mt-5">
            <h1 className="text-info text-center">
                <span className={i18n.language === 'en' ? 'montserrat-black' : 'cairo-black'}>
                    {t("contact_us")}
                </span>
            </h1>
            <p className="text-info text-center">
                <span className={i18n.language === 'en' ? 'montserrat-light' : 'cairo-light'}>
                    {t("contact_us_description")}
                </span>
            </p>

            <div className="row mt-3">
                <div className="col-12 col-md-6 mt-5">
                    <form ref={form} onSubmit={sendEmail}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">{t("name")}:</label>
                            <input type="text" className="form-control" id="name" name="name"
                                placeholder={t("name_desc")} value={name} onChange={handleOnChange} />
                            {errors.name && <small className="text-danger">{t("name_required")}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">{t("your_email")}:</label>
                            <input type="email" className="form-control" id="email" name="email"
                                placeholder={t("your_email_desc")} value={email} onChange={handleOnChange} />
                            {errors.email && <small className="text-danger">{t("email_required")}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">{t("your_phone")}:</label>
                            <input type="tel" className="form-control" id="phone" name="phone"
                                placeholder={t("your_phone_desc")} value={phone} onChange={handleOnChange} />
                            {errors.phone && <small className="text-danger">{t("phone_required")}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="msg" className="form-label">{t("your_msg")}:</label>
                            <textarea className="form-control" id="msg" name="msg"
                                placeholder={t("your_msg_desc")} value={msg} onChange={handleOnChange} />
                            {errors.msg && <small className="text-danger">{t("msg_required")}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="captcha" className="form-label">
                                {t("captcha_msg")} <span className="text-secondary fw-bold">Summit Partners Contracting</span>:
                            </label>
                            <input type="text" className="form-control" id="captcha" name="captcha"
                                placeholder="Summit Partners Contracting" value={captchaWord} onChange={handleCaptchaChange} />
                            {errors.captcha && <small className="text-danger">{t("captcha_incorrect")}</small>}
                        </div>

                        <center>
                            <button type="submit" className={`btn habout-btn ${status === 'sending' ? 'disabled' : ''}`}>
                                <span className={i18n.language === 'en' ? 'montserrat-bold' : 'cairo-bold'}>
                                    {t("submit")}
                                </span>
                            </button>
                        </center>

                        {status === 'sending' && <div className="alert alert-warning mt-3">{t("sending")}</div>}
                        {status === 'sent' && <div className="alert alert-success mt-3">{t("sent")}</div>}
                    </form>
                </div>

                <div className="col-12 col-md-6 bg-light mt-5">
                    <h1 className="text-info text-center mt-3">{t("our_contact")}</h1>
                    <h4 className="text-secondary"><i className="ri-mail-fill"></i> {t("email_contact")}:</h4>
                    <p className="text-info">{t("email")}</p>
                    <h4 className="text-secondary"><i className="ri-map-pin-2-fill"></i> {t("our_location")}:</h4>
                    <p className="text-info">{t("location")}</p>
                    <a href="https://maps.app.goo.gl/NCT3gHFvreB2xtvv9" target="_blank" rel="noreferrer">
                        <img src={Map} alt="Summit Partners Contracting Map" className="img-fluid d-block mx-auto mb-3" />
                    </a>
                </div>
            </div>

            <div className="row mt-5">
                <h1 className="text-info text-center">
                    <span className={i18n.language === 'en' ? 'montserrat-bolder' : 'cairo-bolder'}>
                        {t("connect_with_us")}
                    </span>
                </h1>
                <div className="col-12 d-flex justify-content-center">
                    <div className="col-md-4">
                        <img src={socialmedia} alt="Summit Partners Contracting Social Media QR Code"
                            className="img-fluid mx-auto d-block mt-4" style={{ maxWidth: "300px" }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;